import { noop } from '@garnish/core';

// Not available in web application.
export const useInAppReview = () => {
  return noop;
};
